var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10817_42229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21094 19.6738H0.0078125V11.4707H8.21094V19.6738Z",
    fill: "#2A85FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7073 10.3002H4.3125L10.0099 0.330078L15.7073 10.3002Z",
    fill: "#F9C600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 19.6738C13.6449 19.6738 11.8047 17.8336 11.8047 15.5723C11.8047 13.3109 13.6449 11.4707 15.9062 11.4707C18.1676 11.4707 20.0078 13.3109 20.0078 15.5723C20.0078 17.8336 18.1676 19.6738 15.9062 19.6738Z",
    fill: "#FF6A55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10817_42229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes1);
export default __webpack_public_path__ + "static/media/shapes 1.58dcb165872e1185f7f7be05f3eb9ac4.svg";
export { ForwardRef as ReactComponent };